<template>
  <div class="empty-state-container">
    <div class="empty-state-message">{{ message }}</div>
    <Button 
      icon="pi pi-refresh" 
      :label="buttonLabel" 
      class="empty-state-button"
      @click="$emit('action')" 
      :disabled="isDisabled"
    />
  </div>
</template>

<script setup>
import Button from 'primevue/button';

// Props
const props = defineProps({
  message: {
    type: String,
    default: 'Aucune livraison programmée pour aujourd\'hui'
  },
  buttonLabel: {
    type: String,
    default: 'Actualiser'
  },
  isDisabled: {
    type: Boolean,
    default: false
  }
});

// Emit events
const emit = defineEmits(['action']);
</script>

<style scoped>
.empty-state-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2.5rem 1.5rem;
  margin: 2rem 0;
  background-color: #F9FAFB;
  border-radius: 0.75rem;
  border: 1px dashed #D1D5DB;
  text-align: center;
}

.empty-state-message {
  font-size: 1.1rem;
  color: #6B7280;
  margin-bottom: 1.5rem;
}

.empty-state-button {
  padding: 0.5rem 1.25rem;
  border-radius: 0.5rem;
  font-weight: 500;
  transition: all 0.2s ease;
  background-color: #3B82F6;
  color: white;
  border: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.empty-state-button:hover:not(:disabled) {
  background-color: #2563EB;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(37, 99, 235, 0.2);
}

.empty-state-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style> 